/** 环境类型 */
type Mode = "development" | "test" | "gray" | "production";

const mode = import.meta.env.MODE as Mode;
const hostname = window.location.hostname;

/** 环境配置 */
const ENV_CONFIG = {
  development: {
    mainHosts: ["localhost"],
    domains: [],
  },
  test: {
    mainHosts: ["oversea-miuta-ai-app-node.test.bhbapp.cn"],
    domains: [".test.bhbapp.cn"],
  },
  gray: {
    mainHosts: ["app-gray.miuta.ai"],
    domains: [".miuta.ai"],
  },
  production: {
    mainHosts: ["app.miuta.ai", "app.bizdesk.ai"],
    domains: [".miuta.ai", ".bizdesk.ai"],
  },
} satisfies Record<Mode, { mainHosts: string[]; domains: string[] }>;;

// 解析环境配置
function resolveEnv(mode: Mode, hostname: string) {
  const config = ENV_CONFIG[mode];

  if (!config) {
    return {
      isMain: false,
      isSub: false,
      domainType: "unknown",
    };
  }

  /** 是否主站 */
  const isMain = config.mainHosts.includes(hostname);

  /** 匹配域体系 */
  const matchedDomain = config.domains.find((domain) =>
    hostname.endsWith(domain)
  );

  /**
   * 是否子域
   * 规则：
   * - 必须属于已知域体系
   * - 且不是主站
   */
  const isSub = !!matchedDomain && !isMain;

  return {
    isMain,
    isSub,
    domainType: matchedDomain || "custom", // custom = 完全自定义域名
  };
}

// 解析结果
const { isMain, isSub, domainType } = resolveEnv(mode, hostname);

// 是否开发环境
const isDevEnv = mode === "development" && hostname === "localhost";

// 测试环境
const isTestEnv = mode === "test";
const isTestMainEnv = isTestEnv && isMain;
const isTestSubEnv = isTestEnv && isSub;

// 灰度环境
const isGrayEnv = mode === "gray";
const isGrayMainEnv = isGrayEnv && isMain;
const isGraySubEnv = isGrayEnv && isSub;

// 生产环境
const isProdEnv = mode === "production";
const isProdMainEnv = isProdEnv && isMain;
const isProdSubEnv = isProdEnv && isSub;

// 测试主站 origin
const TEST_MAIN_ENV_ORIGIN = "https://oversea-miuta-ai-app-node.test.bhbapp.cn";

// 统一导出
export const ENV = {
  mode,
  hostname,

  isDevEnv,

  isTestEnv,
  isTestMainEnv,
  isTestSubEnv,

  isGrayEnv,
  isGrayMainEnv,
  isGraySubEnv,

  isProdEnv,
  isProdMainEnv,
  isProdSubEnv,

  isMain,
  isSub,
  domainType,

  testMainEnvOrigin: TEST_MAIN_ENV_ORIGIN,
};